import { useEffect } from 'react';
import { DashboardFilter } from 'generated/maya.types';
import useCountTargetsQuery from 'modules/maya/graphql/queries/countTargets';

const useCountTargetsWidget = (filters?: DashboardFilter) => {
  const { countTargetsQuery, targetsData, loading, error } = useCountTargetsQuery();

  useEffect(() => {
    if (filters) {
      countTargetsQuery({ variables: { filters } });
    }
  }, [filters, countTargetsQuery]);

  return {
    value: targetsData,
    loading,
    error,
  };
};

export default useCountTargetsWidget;
